module.exports = __webpack_public_path__ + "static/media/xata.64b092ad.svg";